import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=2a3f9a35&scoped=true&"
import script from "./upload.vue?vue&type=script&lang=js&"
export * from "./upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3f9a35",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a3f9a35')) {
      api.createRecord('2a3f9a35', component.options)
    } else {
      api.reload('2a3f9a35', component.options)
    }
    module.hot.accept("./upload.vue?vue&type=template&id=2a3f9a35&scoped=true&", function () {
      api.rerender('2a3f9a35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/common/upload.vue"
export default component.exports